(function () {
  const authorizedShop = 'dzi0ii-ej.myshopify.com';
  
  const currentShop = (window.Shopify && window.Shopify.shop) || '';
  if (currentShop && currentShop === authorizedShop) return;
  document.documentElement.innerHTML = '';

  const shopDomain = currentShop || document.location.hostname;
  const whatsappBase = 'https://api.whatsapp.com/send/?phone=923030008477&text=License%20Request%20-%20';
  const whatsappUrl = whatsappBase + encodeURIComponent(shopDomain);

  function injectLicenseOverlay() {
    const watermarkStyle = document.createElement('style');
    watermarkStyle.textContent =
      "body::after{content:'UNLICENSED THEME';position:fixed;bottom:20px;right:20px;" +
      'background:rgba(220,38,38,0.9);color:white;padding:8px 16px;font-size:11px;' +
      'font-weight:700;letter-spacing:1px;border-radius:4px;z-index:2147483646;' +
      'pointer-events:none;font-family:monospace;}';
    document.head.appendChild(watermarkStyle);

    const overlay = document.createElement('div');
    overlay.id = 'bnb-license-overlay';
    overlay.style.cssText =
      'position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.92);' +
      'z-index:2147483647;display:flex;align-items:center;justify-content:center;' +
      'font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;';
    overlay.innerHTML =
      '<div style="background:#fff;border-radius:12px;padding:48px;max-width:520px;width:90%;text-align:center;box-shadow:0 25px 60px rgba(0,0,0,0.3);">' +
        '<div style="width:64px;height:64px;background:#fee2e2;border-radius:50%;display:flex;align-items:center;justify-content:center;margin:0 auto 24px;">' +
          '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#dc2626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
            '<path d="M12 9v4m0 4h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>' +
          '</svg>' +
        '</div>' +
        '<h2 style="margin:0 0 12px;font-size:22px;color:#111;font-weight:700;">Unlicensed Theme</h2>' +
        '<p style="margin:0 0 8px;font-size:15px;color:#555;line-height:1.6;">This theme requires a store license for use.</p>' +
        '<a href="' + whatsappUrl + '" style="display:inline-block;background:#111;color:#fff;padding:12px 32px;border-radius:8px;text-decoration:none;font-size:14px;font-weight:600;">Request License</a>' +
        '<p style="margin:16px 0 0;font-size:12px;color:#999;">Theme by <a href="' + whatsappUrl + '" style="color:#666;">Muhammad Junaid</a></p>' +
      '</div>';

    document.body.appendChild(overlay);
  }

  if (document.body) {
    injectLicenseOverlay();
  } else {
    document.addEventListener('DOMContentLoaded', injectLicenseOverlay);
  }
})();

window.CartApi = {
  _cart: null,
  _queue: Promise.resolve(),
  _cartRequest: null,

  hasCartData(cart = this._cart) {
    return Boolean(cart && (typeof cart.item_count === 'number' || Array.isArray(cart.items)));
  },

  getHeaderSectionId() {
    const headerSections = window.theme?.sections?.header || {};
    return Object.keys(headerSections)[0] || null;
  },

  getHighRiskConfig() {
    const config = window.theme?.settings?.highRiskManagement || {};
    return {
      enabled: Boolean(config.enabled),
      maxCartQuantity: Number.parseInt(config.maxCartQuantity, 10) || 0,
      contactPhone: `${config.contactPhone || ''}`.trim(),
      limitMessage: `${config.limitMessage || ''}`.trim(),
    };
  },

  isHighRiskManagementEnabled() {
    const config = this.getHighRiskConfig();
    return config.enabled && config.maxCartQuantity > 0;
  },

  getItemCount(cart = this._cart) {
    if (!cart) return 0;
    if (typeof cart.item_count === 'number') return cart.item_count;
    if (Array.isArray(cart.items)) {
      return cart.items.reduce((total, item) => total + (Number.parseInt(item.quantity, 10) || 0), 0);
    }
    return 0;
  },

  setCartCache(cart) {
    if (this.hasCartData(cart)) {
      this._cart = cart;
    }
    return this._cart;
  },

  getCartCache() {
    return this.hasCartData() ? this._cart : null;
  },

  clearCartCache() {
    this._cart = null;
    return this._cart;
  },

  getHighRiskLimitMessage() {
    const config = this.getHighRiskConfig();
    const fallbackMessage = config.contactPhone
      ? `For bulk orders, contact our team at ${config.contactPhone}.`
      : 'For bulk orders, contact our team.';
    const template = config.limitMessage || fallbackMessage;
    return template.includes('[phone]')
      ? template.replace(/\[phone\]/g, config.contactPhone || 'our team')
      : template;
  },

  getStockLimitMessage() {
    return 'You already have the maximum available quantity for this item in your cart.';
  },

  normalizeVariantId(value) {
    return `${value ?? ''}`.trim();
  },

  normalizeInventoryData(source) {
    if (!source) {
      return {
        tracked: false,
        inventoryQuantity: 0,
        inventoryManagement: '',
        inventoryPolicy: '',
        continueSelling: false,
      };
    }

    if (typeof source.tracked === 'boolean' && typeof source.inventoryQuantity === 'number') {
      return source;
    }

    const payload = source.dataset || source;
    const inventoryQuantity = Number.parseInt(
      payload.variantInventory ??
        payload.inventoryQuantity ??
        payload.inventory_quantity ??
        payload.inventory ??
        '',
      10
    );
    const inventoryManagement = `${payload.variantInventoryManagement ?? payload.inventoryManagement ?? payload.inventory_management ?? ''}`.trim();
    const inventoryPolicy = `${payload.variantInventoryPolicy ?? payload.inventoryPolicy ?? payload.inventory_policy ?? ''}`.trim();
    const tracked = inventoryManagement !== '' && inventoryManagement !== 'false' && inventoryManagement !== 'null';
    const continueSelling = inventoryPolicy === 'continue';

    return {
      tracked,
      inventoryQuantity: Number.isNaN(inventoryQuantity) ? 0 : inventoryQuantity,
      inventoryManagement,
      inventoryPolicy,
      continueSelling,
    };
  },

  isVariantStockLimited(source) {
    const inventoryData = this.normalizeInventoryData(source);
    return inventoryData.tracked && !inventoryData.continueSelling;
  },

  getVariantInventoryLimit(source) {
    const inventoryData = this.normalizeInventoryData(source);
    if (!this.isVariantStockLimited(inventoryData)) return null;
    return Math.max(inventoryData.inventoryQuantity, 0);
  },

  getVariantCartQuantity(cart = this._cart, variantId, { excludeLine = null } = {}) {
    const normalizedVariantId = this.normalizeVariantId(variantId);
    const excludedLine = Number.parseInt(excludeLine, 10);

    if (!normalizedVariantId || !Array.isArray(cart?.items)) return 0;

    return cart.items.reduce((total, item, index) => {
      const itemVariantId = this.normalizeVariantId(item.variant_id ?? item.variant?.id ?? item.id);
      if (itemVariantId !== normalizedVariantId) return total;
      if (!Number.isNaN(excludedLine) && index + 1 === excludedLine) return total;
      return total + (Number.parseInt(item.quantity, 10) || 0);
    }, 0);
  },

  validateVariantQuantity({ inventoryData, projectedQuantity }) {
    const inventoryLimit = this.getVariantInventoryLimit(inventoryData);
    if (inventoryLimit == null || projectedQuantity <= inventoryLimit) return true;
    throw new Error(this.getStockLimitMessage());
  },

  validateCartVariantQuantity({ cart = this._cart, variantId, inventoryData, nextQuantity, excludeLine = null }) {
    if (!this.isVariantStockLimited(inventoryData)) return true;

    const projectedQuantity =
      this.getVariantCartQuantity(cart, variantId, { excludeLine }) + Math.max(Number.parseInt(nextQuantity, 10) || 0, 0);

    return this.validateVariantQuantity({ inventoryData, projectedQuantity });
  },

  cartHitsHighRiskLimit(totalQuantity) {
    const config = this.getHighRiskConfig();
    if (!this.isHighRiskManagementEnabled()) return false;
    return totalQuantity >= config.maxCartQuantity;
  },

  getRequestedQuantity(formData) {
    const requestedQuantity = Number.parseInt(formData?.get?.('quantity') || '1', 10);
    return Number.isNaN(requestedQuantity) || requestedQuantity < 1 ? 1 : requestedQuantity;
  },

  async validateProjectedCartQuantity(projectedTotalQuantity) {
    if (!this.cartHitsHighRiskLimit(projectedTotalQuantity)) return true;
    throw new Error(this.getHighRiskLimitMessage());
  },

  async validateAddToCart(formData, options = {}) {
    const shouldValidateHighRisk = this.isHighRiskManagementEnabled();
    const shouldValidateInventory = this.isVariantStockLimited(options.variantData);

    if (!shouldValidateHighRisk && !shouldValidateInventory) return true;

    const cart = await this.getCart();

    if (shouldValidateHighRisk) {
      const projectedTotalQuantity = this.getItemCount(cart) + this.getRequestedQuantity(formData);
      await this.validateProjectedCartQuantity(projectedTotalQuantity);
    }

    if (shouldValidateInventory) {
      this.validateCartVariantQuantity({
        cart,
        variantId: formData?.get?.('id'),
        inventoryData: options.variantData,
        nextQuantity: this.getRequestedQuantity(formData),
      });
    }

    return true;
  },

  async validateCheckout() {
    if (!this.isHighRiskManagementEnabled()) return true;

    const cart = await this.getCart({ force: true });
    return this.validateProjectedCartQuantity(this.getItemCount(cart));
  },

  submitFormWithSubmitter(form, submitter) {
    if (!(form instanceof HTMLFormElement)) return;

    let hiddenInput = null;

    if (submitter?.name) {
      hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = submitter.name;
      hiddenInput.value = submitter.value || '';
      form.appendChild(hiddenInput);
    }

    HTMLFormElement.prototype.submit.call(form);

    if (hiddenInput?.parentNode) {
      hiddenInput.parentNode.removeChild(hiddenInput);
    }
  },

  appendCartSections(target) {
    const headerSectionId = this.getHeaderSectionId();
    if (!headerSectionId) return target;

    const sectionsUrl = window.location.pathname + window.location.search;

    if (target instanceof FormData) {
      target.set('sections', headerSectionId);
      target.set('sections_url', sectionsUrl);
      return target;
    }

    return {
      ...target,
      sections: headerSectionId,
      sections_url: sectionsUrl,
    };
  },

  isSameLineItem(cartItem, addedItem, variantId) {
    const cartKey = `${cartItem?.key ?? ''}`.trim();
    const addedKey = `${addedItem?.key ?? ''}`.trim();

    if (cartKey && addedKey) {
      return cartKey === addedKey;
    }

    const cartVariantId = this.normalizeVariantId(cartItem?.variant_id ?? cartItem?.variant?.id ?? cartItem?.id);
    return cartVariantId !== '' && cartVariantId === this.normalizeVariantId(variantId);
  },

  buildOptimisticCartAfterAdd(addResult, { variantId, requestedQuantity } = {}) {
    const cart = this.getCartCache();
    const quantityToAdd = Math.max(Number.parseInt(requestedQuantity, 10) || 0, 0);

    if (!Array.isArray(cart?.items) || quantityToAdd < 1) {
      return null;
    }

    const responseQuantity = Number.parseInt(addResult?.quantity, 10);
    const nextItems = cart.items.map((item) => ({ ...item }));
    const matchIndex = nextItems.findIndex((item) => this.isSameLineItem(item, addResult, variantId));

    if (matchIndex >= 0) {
      const currentQuantity = Number.parseInt(nextItems[matchIndex].quantity, 10) || 0;
      const mergedQuantity =
        Number.isNaN(responseQuantity) || responseQuantity < currentQuantity + quantityToAdd
          ? currentQuantity + quantityToAdd
          : responseQuantity;

      nextItems[matchIndex] = {
        ...nextItems[matchIndex],
        ...addResult,
        quantity: mergedQuantity,
      };
    } else {
      nextItems.push({
        ...addResult,
        quantity: Number.isNaN(responseQuantity) || responseQuantity < 1 ? quantityToAdd : responseQuantity,
      });
    }

    const nextCart = {
      ...cart,
      item_count: this.getItemCount(cart) + quantityToAdd,
      items: nextItems,
    };

    return nextCart;
  },

  /**
   * Adds several line items in one request (main product plus add-ons).
   * The /cart/add.js multi-item response is not a full cart, so the cart
   * cache is rebuilt from /cart.js rather than from the response.
   */
  async addItemsToCart(items, options = {}) {
    const task = this._queue.then(() => this._doAddItemsToCart(items, options));
    this._queue = task.catch(() => {});
    return task;
  },

  async _doAddItemsToCart(items, options = {}) {
    const lineItems = (items || []).filter((item) => item?.id);

    if (!lineItems.length) {
      throw new Error('Could not add to cart');
    }

    if (this.isHighRiskManagementEnabled()) {
      const currentCart = await this.getCart();
      const requestedQuantity = lineItems.reduce(
        (total, item) => total + (Number.parseInt(item.quantity, 10) || 1),
        0
      );
      await this.validateProjectedCartQuantity(this.getItemCount(currentCart) + requestedQuantity);
    }

    if (this.isVariantStockLimited(options.variantData)) {
      const currentCart = await this.getCart();
      this.validateCartVariantQuantity({
        cart: currentCart,
        variantId: lineItems[0].id,
        inventoryData: options.variantData,
        nextQuantity: Number.parseInt(lineItems[0].quantity, 10) || 1,
      });
    }

    const body = new FormData();

    lineItems.forEach((item, index) => {
      body.append(`items[${index}][id]`, item.id);
      body.append(`items[${index}][quantity]`, `${Number.parseInt(item.quantity, 10) || 1}`);

      Object.entries(item.properties || {}).forEach(([key, value]) => {
        if (value === null || value === undefined || `${value}`.trim() === '') return;
        body.append(`items[${index}][properties][${key}]`, value);
      });
    });

    this.appendCartSections(body);

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body,
    });

    if (!response.ok) {
      let error = null;

      try {
        error = await response.json();
      } catch (_) {}

      await this.getCart({ force: true });

      if (response.status === 409) {
        throw new Error('Your cart was updated. Please try again.');
      }

      throw new Error(error?.description || 'Could not add to cart');
    }

    const data = await response.json();
    const cart = await this.getCart({ force: true });
    const detail = data?.sections ? { ...cart, sections: data.sections } : cart;

    this.setCartCache(detail);
    this._pendingCartRefresh = detail;
    return detail;
  },

  async addToCart(formData, options = {}) {
    const task = this._queue.then(() => this._doAddToCart(formData, options));
    this._queue = task.catch(() => {});
    return task;
  },

  async _doAddToCart(formData, options = {}) {
    await this.validateAddToCart(formData, options);
    const requestedQuantity = this.getRequestedQuantity(formData);
    const variantId = formData?.get?.('id');
    const requestBody = this.appendCartSections(formData);
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: requestBody,
    });
    if (!response.ok) {
      let error = null;

      try {
        error = await response.json();
      } catch (_) {}

      if (response.status === 409) {
        await this.getCart({ force: true });
        throw new Error('Your cart was updated. Please try again.');
      }

      throw new Error(error?.description || 'Could not add to cart');
    }
    const data = await response.json();
    const optimisticCart = this.buildOptimisticCartAfterAdd(data, {
      variantId,
      requestedQuantity,
    });

    if (optimisticCart) {
      const nextDetail = {
        ...data,
        item_count: optimisticCart.item_count,
        items: optimisticCart.items,
      };

      this.setCartCache(optimisticCart);
      this._pendingCartRefresh = nextDetail;
      return nextDetail;
    }

    if (this.hasCartData(data)) {
      this.setCartCache(data);
    }
    this._pendingCartRefresh = data;
    return data;
  },

  async getCart({ force = false } = {}) {
    if (!force) {
      const cachedCart = this.getCartCache();
      if (cachedCart) return cachedCart;
      if (this._cartRequest) return this._cartRequest;
    }

    const request = fetch('/cart.js')
      .then(async (response) => {
        if (!response.ok) {
          throw new Error('Could not load cart');
        }

        return response.json();
      })
      .then((cart) => {
        this.setCartCache(cart);
        return cart;
      });

    this._cartRequest = request.finally(() => {
      if (this._cartRequest === request) {
        this._cartRequest = null;
      }
    });

    return this._cartRequest;
  },

  async refreshCart(detail = this._pendingCartRefresh) {
    if (detail?.sections) {
      if (this.hasCartData(detail)) {
        this.setCartCache(detail);
      } else {
        this.clearCartCache();
        void this.getCart().catch(() => {});
      }

      this._pendingCartRefresh = null;
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail }));
      return detail;
    }

    const cart = await this.getCart({ force: true });
    this._pendingCartRefresh = null;
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
    const countElements = document.querySelectorAll('.custom-header__cart-count');
    countElements.forEach((el) => {
      el.textContent = cart.item_count;
      el.classList.toggle('hidden', cart.item_count === 0);
    });
    return cart;
  },

  /**
   * Opens the cart drawer in its "adding" state and waits for it to paint, so the
   * add request (which analytics/apps may hook and block on) starts after the UI responds.
   * Resolves true when the drawer is showing; false means use the legacy open-after-add path.
   */
  async beginDrawerAdd() {
    // Either header can own the cart UI: the drawer (header) or the popover (simple-header).
    const shown = window.CustomHeaderCart?.showAdding?.() || window.SimpleHeaderCart?.showAdding?.();
    if (!shown) return false;
    await new Promise((resolve) => requestAnimationFrame(() => setTimeout(resolve)));
    return true;
  },

  cancelDrawerAdd() {
    window.CustomHeaderCart?.cancelAdding?.();
    window.SimpleHeaderCart?.cancelAdding?.();
  },

  showToast(message, isError = false) {
    const existing = document.querySelector('.toast-notification');
    if (existing) existing.remove();

    const toast = document.createElement('div');
    toast.className = 'toast-notification';
    toast.setAttribute('role', 'alert');
    toast.setAttribute('aria-live', 'assertive');
    toast.textContent = message;
    toast.style.cssText = `
      position: fixed;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      background: ${isError ? '#dc3545' : '#333'};
      color: white;
      padding: 12px 24px;
      border-radius: 4px;
      font-size: 14px;
      z-index: 9999;
      animation: toastFadeIn 0.3s ease;
    `;

    document.body.appendChild(toast);

    setTimeout(() => {
      toast.style.animation = 'toastFadeOut 0.3s ease';
      setTimeout(() => toast.remove(), 300);
    }, 3000);
  }
};

const style = document.createElement('style');
style.textContent = `
  @keyframes toastFadeIn {
    from { opacity: 0; transform: translateX(-50%) translateY(20px); }
    to { opacity: 1; transform: translateX(-50%) translateY(0); }
  }
  @keyframes toastFadeOut {
    from { opacity: 1; transform: translateX(-50%) translateY(0); }
    to { opacity: 0; transform: translateX(-50%) translateY(20px); }
  }
`;
document.head.appendChild(style);
